import React, { useState } from "react";
import "./email.css";
import MaterialInput from "../../../components/MaterialInput";
import Grid from "@mui/material/Grid2";
import { useNavigate } from "react-router-dom";
import request from "graphql-request";
import BASEURL from "../../Utils/Baseurl";
import { REQUEST_PASSWORD_URL } from "../../../lib/graphQL/graphMutation";
import MaterialTypography from "../../../components/MaterialTypography";
import { useLoading } from "../../../context/LodingContext";
import { useSuccess } from "../../../context/SucccessContext";
import { useError } from "../../../context/ErrorContext";

const EmailForgot = () => {
  const navigate = useNavigate();
  const { successStatus, setSuccessStatus, setSucessTitle } = useSuccess();
  const { errorStatus, setErrorStatus, errormessage, setErrormessage } = useError();
  const [email, setEmail] = useState({
    emailId: "",
    emailStatus: "unchecked",
  });
  const [emailSuccess, setEmailSuccess] = useState(false);
  const { circleLoading, setCirleLoading } = useLoading();

  const handleChange = (event) => {
    const emailRegex = new RegExp(/^[\w-\.]+@([\w-]+\.)+[\w-]{2,6}$/g);
    let signInState = { ...email };
    if (event.target.name === "emailId") {
      if (emailRegex.test(event.target.value) === true) {
        signInState.emailStatus = "success";
      } else {
        signInState.emailStatus = "error";
      }
      signInState[event.target.name] = event.target.value;
    }
    setEmail(signInState);
  };
  const handlesend = async () => {
    setCirleLoading(true);
    // e.preventDefault();
    try {
      const response = await request(BASEURL, REQUEST_PASSWORD_URL, {
        email: email?.emailId,
      });

      setEmailSuccess(true);
      const successStatus = response.forgotPassword.success;
      const responseMessage = response.forgotPassword.error;

      if(successStatus)
      {
          setSuccessStatus(true);
          setSucessTitle("Reset Link Sent");
          setTimeout(() => {
            setSuccessStatus(false);
            navigate("/sign-in");
          }, 1000);
      }
      else{
        setErrorStatus(true);
        setErrormessage(responseMessage);
        setTimeout(() => {
          setErrorStatus(false);
        }, 3000);
      }
      
    } catch (err) {
      console.error(err);
    } finally {
      setCirleLoading(false);
    }
    // navigate("/sign-in/resetPassword");
  };
  return (
    <div className="form-layout">
      <div class="form-container">
        <MaterialTypography class="logo-container">
          Forgot Password
        </MaterialTypography>
        <MaterialTypography variant="h6" fontWeight="medium">
          Enter your email to reset your password
        </MaterialTypography>
        {/* <form class="form">
          <div class="form-group"> */}

        {/* <input
              type="text"
              id="email"
              name="email"
              placeholder="Enter your email"
              required=""
            /> */}
        {emailSuccess && (
          <p className="sendsuccess">Reset link sent to your Email</p>
        )}
        <Grid size={{ xs: 12, sm: 12 }}>
          <label for="email">Email</label>
          <MaterialInput
            fullWidth
            placeholder="Email"
            name="emailId"
            // type="email"
            variant="outlined"
            value={setEmail?.emailId}
            onChange={handleChange}
            error={email?.emailStatus === "error" ? true : false}
            success={email?.emailStatus === "success" ? true : false}
          />
          {/* {signInData.passwordStatus === "error" ? (
                    <FormControl error>
                      <FormHelperText>
                        Your password must be minimum 1 characters.
                      </FormHelperText>
                    </FormControl>
                  ) : null} */}
        </Grid>
        <button
          onClick={() => handlesend()}
          class={`form-submit-btn`}
          type="submit"
        >
          Send Email
        </button>
      </div>

      {/* </form>
      </div> */}
    </div>
  );
};

export default EmailForgot;
